import type { ActorEvent, RecordLikeProtocol, SizeConfigure } from '@lighthouse/core'
import type { FlowLayoutNode } from '@lighthouse/shared'
import React, { memo } from 'react'
import styled from 'styled-components'

import { Item } from '../CustomViewBlock/Item'
import { setDeadCopyNode } from '../CustomViewBlock/utils'

interface MatrixCellProps extends React.HTMLAttributes<HTMLDivElement> {
    canEdit: boolean
    node: FlowLayoutNode
    blockId: string
    title: string
    records: RecordLikeProtocol[]
    rowKey: string
    colKey: string
    recordIndexPath: string
    readonly?: boolean
    onRecordClick?: (id: string, actorEvent: ActorEvent, record?: RecordLikeProtocol) => Promise<void>
}

const CellContainer = styled.div``

export const MatrixCell: React.FC<MatrixCellProps> = memo(
    ({ canEdit, node, blockId, title, records, rowKey, colKey, recordIndexPath, readonly, onRecordClick, ...rest }) => {
        const minHeightConfigure =
            node.children && node.children.length > 0
                ? {}
                : {
                      minHeight: {
                          size: 40,
                          unit: 'px'
                      } as SizeConfigure
                  }
        const record = records[0]

        return (
            <CellContainer {...rest}>
                {record ? (
                    <Item
                        key={record.id}
                        data-record-id={record.id}
                        recordId={record.id}
                        recordIndexPath={recordIndexPath}
                        readonly={readonly}
                        style={{ height: '100%' }}
                        data={{
                            id: `${blockId}/${record.id}`,
                            scope: node.scope,
                            type: 'container',
                            disabled: readonly || !canEdit,
                            virtual: true,
                            data: node.data && {
                                design: node.data.design,
                                size: {
                                    width: { size: 'fill' },
                                    height: { size: 'auto' },
                                    ...minHeightConfigure
                                },
                                layout: node.data.layout,
                                position: node.data.position
                            },
                            children: readonly ? node.children : setDeadCopyNode(node.children || [], canEdit, blockId)
                        }}
                        title={title}
                        onRecordClick={onRecordClick}
                    />
                ) : null}
            </CellContainer>
        )
    }
)
